import { useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { CreateUsersDocument, ListUsersDocument } from "../../gql/graphql";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import { AlertComponent } from "../../components/shared/AlertComponent";
import { HeadingComponent } from "../../components/shared/HeadingComponent";
import { InputComponent } from "../../components/shared/InputComponent";
import { ModalComponent } from "../../components/shared/ModalComponent";
import { NblocksButton } from "../../components/shared/NblocksButton";
import { TextComponent } from "../../components/shared/TextComponent";
import { UserListTableComponent } from "../../components/shared/UserListTableComponent";
import { useTranslation } from "react-i18next";
const UserListScreen = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "min-h-screen flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center py-5 mx-6"
  }, /*#__PURE__*/React.createElement(HeadingComponent, {
    type: "h1",
    size: "3xl",
    className: "inline-block"
  }, t("Users")), /*#__PURE__*/React.createElement(InviteUserBtn, null)), /*#__PURE__*/React.createElement("div", {
    className: "grow flex flex-col justify-between"
  }, /*#__PURE__*/React.createElement(UserListTableComponent, null))));
};
const InviteUserBtn = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [usernames, setUsernames] = useState([""]);
  const [inviteUserMutation, inviteUserMutationData] = useMutation(CreateUsersDocument);
  const {
    t
  } = useTranslation();
  const [alert, setAlert] = useState({
    title: "",
    type: "primary",
    messages: [""],
    onCloseClick: event => {
      setAlert(value => {
        return {
          ...value,
          show: false
        };
      });
    },
    show: false
  });
  const inviteUsers = async () => {
    await inviteUserMutation({
      variables: {
        userNames: usernames.filter(username => username.length > 0)
      },
      refetchQueries: [{
        query: ListUsersDocument
      }]
    });
  };
  useEffect(() => {
    if (!isOpen) {
      setUsernames([""]);
    }
  }, [isOpen]);
  useEffect(() => {
    if (alert.show) {
      setTimeout(() => {
        setAlert(value => {
          return {
            ...value,
            show: false
          };
        });
      }, 5000);
    }
  }, [alert.show]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NblocksButton, {
    type: "primary",
    size: "md",
    onClick: () => {
      setIsOpen(true);
    }
  }, t("Add user"))), /*#__PURE__*/React.createElement(ModalComponent, {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    icon: /*#__PURE__*/React.createElement(UserPlusIcon, null),
    heading: t("Add user"),
    description: t("Add one or multiple users. You can change their role in the table after they are added.")
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-3 mt-5"
  }, usernames.map((username, i) => /*#__PURE__*/React.createElement(InputComponent, {
    key: `email${i}`,
    type: "email",
    label: i === 0 ? t("Email address") : undefined,
    placeholder: t("you@domain.com"),
    name: `email${i}`,
    value: username,
    labelClassName: "mt-4",
    onChange: event => {
      const values = [...usernames];
      values[i] = event.target.value;
      setUsernames(values);
    }
  })), /*#__PURE__*/React.createElement(NblocksButton, {
    onClick: () => {
      setUsernames([...usernames, ...[""]]);
    }
  }, /*#__PURE__*/React.createElement(TextComponent, {
    size: "sm",
    className: "font-semibold",
    colorName: "text-purple-700"
  }, t("+ Add another")))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col-reverse md:flex-row md:justify-between mt-8 gap-3"
  }, /*#__PURE__*/React.createElement(NblocksButton, {
    size: "md",
    className: "w-full",
    type: "tertiary",
    onClick: () => setIsOpen(false)
  }, t("Cancel")), /*#__PURE__*/React.createElement(NblocksButton, {
    size: "md",
    className: "w-full",
    type: "primary",
    onClick: () => {
      inviteUsers();
      setIsOpen(false);
      setAlert(value => {
        return {
          ...value,
          title: t("Invite has been sent!"),
          show: true,
          type: "success",
          messages: [`Workspace invatation has been sent to users: ${usernames.filter(Boolean).join(" ")}`]
        };
      });
    }
  }, t("Add")))), alert.show && /*#__PURE__*/React.createElement(AlertComponent, {
    title: alert.title,
    type: alert.type,
    className: "fixed bottom-4 right-4 z-50 max-w-md w-full",
    messages: alert.messages,
    closable: true,
    onCloseClick: alert.onCloseClick
  }));
};
export { UserListScreen };